import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  IApiResponse,
  IDeliveryOrder,
  IDeliveryOrderDetail,
  IGetDeliveryOrderDetail,
  IUpdateDeliveryOrderRequest,
} from "model";
import { IErrorResponse } from "model/Common/IErrorResponse";
import { IPaginateApiResponse } from "model/Common/IPaginateApiResponse";
import { IPaginationRequest } from "model/Common/IPaginationRequest";
import { call, put, takeEvery } from "redux-saga/effects";
import { DeliveryOrderActions } from "redux/actions";
import DeliveryOrderApiService from "services/DeliveryOrderApiService";

function* getAllDeliveryOrders(action: PayloadAction<IPaginationRequest>) {
  try {
    const result: IPaginateApiResponse<IDeliveryOrder[]> = yield call(
      DeliveryOrderApiService.getAllDeliveryOrders,
      action.payload
    );
    if (result.succeeded) {
      yield put(DeliveryOrderActions.getAllDeliveryOrders.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(DeliveryOrderActions.getAllDeliveryOrders.failed(error));
    }
  } catch (error) {
    yield put(DeliveryOrderActions.getAllDeliveryOrders.failed(error));
  }
}

function* getDeliveryOrderDetail(
  action: PayloadAction<IGetDeliveryOrderDetail>
) {
  try {
    const result: IPaginateApiResponse<IDeliveryOrderDetail[]> = yield call(
      DeliveryOrderApiService.getDeliveryOrderDetail,
      action.payload
    );
    if (result.succeeded) {
      yield put(DeliveryOrderActions.getDeliveryOrderDetail.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(DeliveryOrderActions.getDeliveryOrderDetail.failed(error));
    }
  } catch (error) {
    yield put(DeliveryOrderActions.getDeliveryOrderDetail.failed(error));
  }
}

function* updateDeliveryOrder(
  action: PayloadAction<IUpdateDeliveryOrderRequest>
) {
  try {
    const result: IApiResponse<IDeliveryOrder> = yield call(
      DeliveryOrderApiService.updateDeliveryOrder,
      action.payload
    );
    if (result.succeeded) {
      yield put(DeliveryOrderActions.updateDeliveryOrder.success(result.data!));
      AlertHelper.showAlert("Update Document Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(DeliveryOrderActions.updateDeliveryOrder.failed(error));
    }
  } catch (error) {
    yield put(DeliveryOrderActions.updateDeliveryOrder.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(
    DeliveryOrderActions.getAllDeliveryOrders.request,
    getAllDeliveryOrders
  );
  yield takeEvery(
    DeliveryOrderActions.getDeliveryOrderDetail.request,
    getDeliveryOrderDetail
  );
  yield takeEvery(
    DeliveryOrderActions.updateDeliveryOrder.request,
    updateDeliveryOrder
  );
}
